export const ENVIRONMENT_LOCAL = 'local';
export const ENVIRONMENT_DEV = 'dev';
export const ENVIRONMENT_STAGING = 'staging';
export const ENVIRONMENT_PRODUCTION = 'production';

/*
The variable below is used to swap out the real Wind Creek GraphQL API for a mock API for testing. To enable, change it
to a string that contains the full hostname (including https://) of your mock API server. For example, this can be used
with Postman's mock servers.

Note that in most cases, using this variable is unnecessary and it can be set to false. The API client code is already
configured to use the development/test version of the real Wind Creek API in the correct environment. You only need to
use this variable if you need full control over the API responses for advanced testing.

This variable is ignored on production. It only has effect on non-prod environments.
*/
export const MOCK_WC_GRAPHQL_API = false; // 'https://7d5a196e-acb0-4615-8fda-7e1c1f807414.mock.pstmn.io';

const localDomains = [
  'localhost',
  'wc2024.ddev.site',
  'wind-creek-casino-2024.ddev.site',
  'outlets2024.site',
  'weddings.ddev.site',
  'rewards.ddev.site',
  'magiccitycasino.ddev.site',
  'magiccityrewards.ddev.site',
];

const devDomains = [
  'windcreekdev.prod.acquia-sites.com',
  'windcreek.amdevel.com',
  'outletsatwindcreekbethlehem.amdevel.com',
  'windcreekweddings.amdevel.com',
  'windcreekrewards.amdevel.com',
  'magiccitycasino.amdevel.com',
  'magiccityrewards.amdevel.com',
];

const stagingDomains = [
  'windcreekstage.prod.acquia-sites.com',
  'stage.windcreek.amdevel.com',
  'stage.outletsatwindcreekbethlehem.amdevel.com',
  'stage.windcreekweddings.amdevel.com',
  'stage.windcreekrewards.amdevel.com',
  'stage.magiccitycasino.amdevel.com',
  'stage.magiccityrewards.amdevel.com',
];

let current = '';

if (localDomains.includes(location.hostname)) {
  current = ENVIRONMENT_LOCAL;
} else if (devDomains.includes(location.hostname)) {
  current = ENVIRONMENT_DEV;
} else if (stagingDomains.includes(location.hostname)) {
  current = ENVIRONMENT_STAGING;
} else {
  current = ENVIRONMENT_PRODUCTION;
}

export const CURRENT = current;
